import type { MomentCoupon } from "../../data/momentOptions";
import ButtonsRow from "./ButtonsRow";
import CouponPreview from "./CouponPreview";
import FooterBar from "./FooterBar";

type Props = {
  body: string;
  displayButtons: { id: string; title: string }[];
  shareFlag: boolean;
  couponEnabled: boolean;
  coupon: MomentCoupon;
};

export default function BasicTextPreview({ body, displayButtons, shareFlag, couponEnabled, coupon }: Props) {
  const previewBody = body.trim() || "내용을 입력해주세요";

  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <div className="tw-flex-1 tw-bg-white tw-rounded-lg tw-shadow-sm tw-overflow-hidden tw-text-[13px] tw-leading-relaxed">
        <div className="tw-p-4 tw-break-all">
          <p className="tw-whitespace-pre-line tw-text-gray-800">{previewBody}</p>
        </div>
        {displayButtons.length > 0 && <ButtonsRow buttons={displayButtons} />}
        <CouponPreview couponEnabled={couponEnabled} coupon={coupon} />
        <FooterBar />
      </div>
      {shareFlag && (
        <div className="tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-rounded-full tw-bg-gray-300">
          <div className="tw-flex tw-items-center tw-justify-center tw-w-7 tw-h-7">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="tw-text-gray-700">
              <path
                d="M12 4.5C7.03 4.5 3 7.63 3 11.49c0 2.48 1.67 4.66 4.18 5.89l-.84 3.12a.42.42 0 0 0 .63.47l3.77-2.5c.41.05.83.07 1.26.07 4.97 0 9-3.13 9-6.99S16.97 4.5 12 4.5Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
      )}
    </div>
  );
}
